import React from 'react'
import { Box } from '@mui/material'
import { muiGrey } from 'src/style/muiTheme'

type Props = {
  itemIndex: number
  cell: {
    head: string
    label: string
    value?: string
  }
  color?: string
  isNewLine?: boolean
}

export const ItemCell: React.FC<Props> = ({ itemIndex, cell, color, isNewLine }) => {
  return (
    <Box ml={1} mb={isNewLine ? 0.3 : 0} color={muiGrey}>
      {`(${itemIndex}) ${cell.head}: `}
      {isNewLine && <br />}
      <Box component="span" fontWeight="bold" color={color} pl={isNewLine ? 1 : 0}>
        {cell.label}
      </Box>
    </Box>
  )
}
